import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid2,
  Radio,
  RadioGroup,
  Theme,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ChangeEvent, useState } from 'react';
import ScheduleMeetingModal from '../../../ScheduleMeetingModal/ScheduleMeetingModal';
import { RoomPrivacyType } from '../../../../types';

const useStyles = makeStyles((theme: Theme) => ({
  roomTypeLegend: {
    fontSize: '1.25rem',
    color: '#000',
  },
  roomTypeLegendFocused: {
    color: '#000 !important',
  },
}));

type RoomOptionsProps = {
  shouldRecord: boolean;
  setShouldRecord: React.Dispatch<React.SetStateAction<boolean>>;
  roomPrivacy: RoomPrivacyType;
  setRoomPrivacy: React.Dispatch<React.SetStateAction<RoomPrivacyType>>;
};

const RoomOptions: React.FC<RoomOptionsProps> = ({ setShouldRecord, shouldRecord, roomPrivacy, setRoomPrivacy }) => {
  const classes = useStyles();
  const [showMeetingModal, setShowMeetingModal] = useState(false);

  const handleRoomTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomPrivacy((event.target as HTMLInputElement).value as RoomPrivacyType);
  };

  const handleShouldRecordChange = (event: ChangeEvent<HTMLInputElement>) => {
    setShouldRecord((event.target as HTMLInputElement).value === 'true');
  };

  return (
    <Grid2 container spacing={{ xs: 1, md: 4 }} flexGrow={1}>
      <Grid2 size="auto">
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            classes={{ root: classes.roomTypeLegend, focused: classes.roomTypeLegendFocused }}
          >
            <Typography variant="h6">Room Type</Typography>
          </FormLabel>
          <RadioGroup
            name="roomPrivacy"
            value={roomPrivacy}
            aria-label="room type"
            onChange={handleRoomTypeChange}
            row={true}
          >
            <FormControlLabel
              value="public"
              control={<Radio size="small" />}
              label={<Typography variant="body1">Public</Typography>}
            />
            <FormControlLabel
              value="private"
              control={<Radio size="small" />}
              label={<Typography variant="body1">Private</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Grid2>
      <Grid2 size="auto">
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            classes={{ root: classes.roomTypeLegend, focused: classes.roomTypeLegendFocused }}
          >
            <Typography variant="h6">Record meeting</Typography>
          </FormLabel>
          <RadioGroup
            name="record"
            value={shouldRecord}
            aria-label="should record"
            onChange={handleShouldRecordChange}
            row={true}
          >
            <FormControlLabel
              value={true}
              control={<Radio size="small" />}
              label={<Typography variant="body1">Yes</Typography>}
            />
            <FormControlLabel
              value={false}
              control={<Radio size="small" />}
              label={<Typography variant="body1">No</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Grid2>
      <Grid2 size="grow" display="flex" justifyContent="flex-end" alignItems="baseline">
        <Button type="button" variant="outlined" color="primary" onClick={() => setShowMeetingModal(true)}>
          Schedule a Meeting
        </Button>
        <ScheduleMeetingModal open={showMeetingModal} onClose={() => setShowMeetingModal(false)} />
      </Grid2>
    </Grid2>
  );
};

export default RoomOptions;
